import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API, // api的base_url
	timeout: 15000, // 请求超时时间
})
// request拦截器
service.interceptors.request.use(config => {
	return config
}, error => {
	Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		return res
	},
	error => {
		console.log('请求错误：' + error) // for debug
		// return Promise.reject(error)
		 // ========== 关键修复：先判断是否有 response ==========
		if (!error.response) {
			// 1. 处理网络错误（Network Error）和超时（timeout）
			console.warn('网络错误或请求超时:', error.message)
			
			return Promise.resolve({
				code: -1,
				success: false,
				message: '网络连接失败，请检查网络设置',
				data: null
			})
		}
		
		// 2. 处理有响应的 HTTP 错误（401, 404, 500等）
		const status = error.response.status
		let message = '请求失败'
		
		// 根据状态码设置不同的提示信息
		switch (status) {
		case 400:
			message = '请求参数错误'
			break
		case 401:
			message = '未授权，请重新登录'
			// 可以在这里跳转到登录页
			// router.replace('/login')
			break
		case 403:
			message = '拒绝访问'
			break
		case 404:
			message = '请求资源不存在'
			break
		case 408:
			message = '请求超时'
			break
		case 500:
			message = '服务器内部错误'
			break
		case 501:
			message = '服务未实现'
			break
		case 502:
			message = '网关错误'
			break
		case 503:
			message = '服务不可用'
			break
		case 504:
			message = '网关超时'
			break
		default:
			message = error.response.data?.message || '请求失败'
		}
		
		return Promise.resolve({
		code: status,
		success: false,
		message: message,
		data: null
		})
	}
)

export default service